
export class DeskBasic {

    private centerName: string;
    private turnDeskName: string;
    private turnDeskInternalId: string;

    constructor(centerName?: string, turnDeskName?: string, turnDeskInternalId?: string) {
            this.centerName = centerName;
            this.turnDeskName = turnDeskName;
            this.turnDeskInternalId = turnDeskInternalId;
    }

    public get CenterName() {
        return this.centerName;
    }
    public get TurnDeskName() {
        return this.turnDeskName;
    }
    public get TurnDeskInternalId() {
        return this.turnDeskInternalId;
    }
    public set CenterName(centerName) {
        this.centerName = centerName;
    }
    public set TurnDeskName(turnDeskName) {
        this.turnDeskName = turnDeskName;
    }
    public set TurnDeskInternalId(turnDeskInternalId) {
        this.turnDeskInternalId = turnDeskInternalId;
    }
}
